var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 103,
    viewBox: "0 0 104 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618874578 1",
    clipPath: "url(#clip0_1513_1591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.6985 96.0648C69.6985 96.0648 36.4462 82.8595 27.1978 79.2981C15.5497 74.8132 1.44073 61.6907 10.8024 45.3758C20.1641 29.0608 43.7696 41.835 48.1978 50.1651C48.1978 50.1651 39.0136 15.7526 58.96 16.2644C78.9064 16.7762 77.515 44.5863 77.3073 58.6461C77.0304 78.4856 69.6985 96.0648 69.6985 96.0648Z",
    fill: "#D31C4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1513_1591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 77,
    fill: "white",
    transform: "translate(0 64.0859) rotate(-60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/redHeart.bb0a0a48d5b4bda21eed60d72fe030d8.svg";
export { ForwardRef as ReactComponent };